// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"8ab1f9c4","94":"cb21d9f6","312":"c2e55eb3","488":"728259ff","595":"bcb088de","950":"b90733b5"}[chunkId] + ".chunk.js";
};